module.exports = __webpack_public_path__ + "img/senalando_top.7b73728f.png";